import { Navigate,Outlet } from "react-router-dom"
import React from "react"
const ProtectedRouteAdmin = ({status}) =>{
    if (status.status && (status.Role === "admin"))
        return <Outlet />
    else
        return <Navigate to="/Login" replace/>
}
export default ProtectedRouteAdmin